<template>
  <div class="member_footprint_box">
    <div class="member_footprint_title">我的足迹</div>
    <div class="footprint_delete_all clearfix_">
      <p class="fr">
        <i class="fl"></i>
        <span @click="deleteFootprint" class="fl">清空足迹</span>
      </p>
    </div>
    <!-- <div class="footprint_header">我的足迹</div> -->
    <div class="footprint_goods" v-show="footprintList.length">
      <ul class="clearfix_ footprint_goods_list">
        <li style="height:320px;" class="coupon_detail_goods_list_item member_collections_item" @click="gotoDetails(item.webname,item.goodsId,item.supplyChainTenantId)" v-for="(item,index) in footprintList" :key="index">
          <div class="goodslistpicbox">
            <img :title="item.goodsAlias?item.goodsAlias:item.goodname" :src="item.pic1?item.pic1:timg" width="225" height="225"/>
            <div v-show="!item.isShow" class="invalid_collections_goods_txt">已失效</div>
          </div>
          <div class="goodslistprice clearfix_">
            <p class="fl">¥ {{item.price}}</p>
          </div>
          <div class="goodslistnamebox">
            <p :title="item.goodsAlias?item.goodsAlias:item.goodname">{{item.goodsAlias?item.goodsAlias:item.goodname}}</p>
          </div>
        </li>


        <!-- <li class="fl footprint_goods_item" @click="gotoDetails(item.webname,item.goodsId,item.supplyChainTenantId)" v-for="(item,index) in footprintList" :key="index">
          <div class="footprint_goods_img"><img :src="item.pic1?item.pic1:timg" alt=""></div>
          <p class="footprint_goods_name">{{item.goodsAlias?item.goodsAlias:item.goodname}}</p>
          <p class="footprint_goods_price">¥{{item.price}}</p>
        </li> -->


      </ul>
      <div v-show="total" class="footprint_goods_pages">
         <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div> 
      </div>
    </div>
    <div class="no" v-show="!total&&noData">暂时没有任何足迹</div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  inject:['reload'],
  data(){
    return {
      total:0,
      currentPage3:1,
      footprintList:[],
      timg:require('../../assets/img/timg.gif'),
      noData:false
    }
  },
  mounted:function(){
    var t_=this
    t_.getFootprint(t_.currentPage3)
  },
  methods:{
    gotoDetails:function(web,id,supplyChainTenantId){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id+'&supplyChainTenantId='+supplyChainTenantId+'&isSupplyChainGoods='+2
      window.open(url,'_blank')
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.currentPage3=val
      this.footprintList=[]
      this.getFootprint(val)
    },
    getFootprint:function(val){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        page:val,
        pagesize:20
      })
      axios.post(`${ip}formWorkInterface/getFootPrint`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.total=res.data.data.total
          t_.footprintList=res.data.data.rows
          if(t_.footprintList.length==0)t_.noData=true
        }
      })
    },
    deleteFootprint:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2
      })
      axios.post(`${ip}formWorkInterface/deleteFootPrint`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          this.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          this.reload()
        }else{
          this.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    }
  }
}
</script>
<style>
  .member_footprint_box{
    border:1px solid #ddd;
    position: relative;
  }
  .member_footprint_title{
    height: 38px;
    line-height: 38px;
    font-size:16px;
    font-weight: 900;
    background: #fafafa;
    padding-left: 10px;
  }
  .footprint_header{
    width: 1050px;
    font-size:18px;
    font-weight: 900;
    height: 40px;
    background: #fff;
    line-height: 40px;
    padding-left: 18px;
    margin-bottom: 10px;
  }
  .footprint_goods{
    background: #fff;
    /* width: 1068px; */
    padding-bottom: 5px;
  }
  .footprint_delete_all{
    height: 40px;
    margin-bottom: 20px;
    position: absolute;
    top:0;
    right:0;
  }
  .footprint_delete_all p{
    line-height: 40px;
    margin-right: 30px;
  }
  .footprint_delete_all i{
    width: 15px;
    height: 15px;
    background: url(../../assets/img/delete_.png);
    margin-top: 14px;
    margin-right: 5px;
  }
  .footprint_delete_all span{
    cursor: pointer;
  }
  .footprint_goods .footprint_goods_item{
    width: 160px;
    height: 233px;
    border: 1px solid #eee;
    margin-right: 12px;
    margin-bottom: 15px;
    position: relative;
    cursor: pointer;
  }
  .footprint_goods_img{
    width: 160px;
    height: 160px;
  }
  .footprint_goods_img img{
    width: 160px;
    height: 160px;
  }
  .footprint_goods_name{
    width: 140px;
    height: 38px;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    padding: 0 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .footprint_goods_price{
    padding: 0 10px;
    color:#d00;
  }
  .footprint_goods_bg{
    width: 16px;
    height: 16px;
    background: rgba(0,0,0,.7) url(../../assets/img/delete_.png);
    position: absolute;
    top:5px;
    right:5px;
    display: none;
    cursor: pointer;
  }
  .footprint_goods .footprint_goods_item:hover .footprint_goods_bg{
    display: block;
  }
  .footprint_goods_pages{
    text-align: center;
    margin-bottom: 15px;
  }
  .footprint_goods_pages .el-pagination__jump{
    margin-top:-9px;
  }
  .footprint_goods_pages .el-pagination__editor{
    top:9px;
  }
  .no{
    width: 1068px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #fff;
  }
  .footprint_goods_list{
    background: #fff;
    padding: 10px;
  }
  .footprint_goods_list > ul > li{
    width: 238px;
    height: 379px;
    border: 1px solid #ddd;
    background: #fff;
    margin: 0 16px 20px 0;
    position: relative;
  }
  .footprint_goods_list > ul > li:nth-child(4n){
    margin-right: 0;
  }
  .footprint_goods_list img{
    width: 225px;
    height: 225px;
  }
  .footprint_goods_list .pic{
    width: 225px;
    height: 225px;
    overflow: hidden;
    margin-bottom: 15px;
  }

  
  .footprint_goods_list li{
    width: 224px;
    height: 352px;
    padding: 10px;
    margin-right: 2px;
    float: left;
    margin-bottom: 10px;
    border: 1px solid white;
  }
  .footprint_goods_list .coupon_detail_goods_list_item{
    margin-right: 72px;
    margin-bottom: 20px;
    position: relative;
  }
  .footprint_goods_list .coupon_detail_goods_list_item:nth-child(4n){
    margin-right: 0;
  }
  .footprint_goods_list li:nth-child(4n+0){
    margin-right: 0;
  }
  .footprint_goods_list li:hover{
    border: 1px solid #dd2a3c;
    border-radius: 3px;
    box-shadow: 0 0 1px #999;
  }
  .footprint_goods_list li a{
    text-decoration: none;
  }
  .goodslistpicbox{
    height: 225px;
  }
  .goodslistprice p{
    height: 45px;
    line-height: 45px;
    text-align: left;
    color: #dd2a3c;
    font-size: 22px;
  }
  .goodslistnamebox p{
    text-align: left;
    font-size: 12px;
    color: #313030;
    height: 35px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    cursor: pointer;
  }
  .goodslistnamebox p:hover{
    color: #dd2a3c;
    text-decoration: underline;
  }
  .goodslistBtnBox{
    cursor: pointer;
    width: 50%;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #dd2a3c;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 10px;
    /*display: none;*/
  }
   /* .el-pagination .el-pagination__jump{
    margin-top:-10px;
  } */
  .goodslistprice  .teamPriceAndNum{
    font-size: 14px;
  }
  .goodslistprice  .teamPriceAndNum span{
    margin-right: 5px;
  }
  .goodslistprice  .teamPriceAndNum  i{
    width: 55px;
    height: 18px;
    background:#dd2a3c;
    line-height: 18px;
    text-align: center;
    color:#fff;
    margin-top: 13px;
  }
  .member_collections_delete_goods{
    position: absolute;
    top: 193px;
    left: 0;
    width: 100%;
    height: 32px;
    padding: 5px 0;
    text-align: center;
    z-index: 2;
    background-color: rgba(255,255,255,.8);
    -webkit-transition: bottom .1s ease-in-out;
    transition: bottom .1s ease-in-out;
    display: none;
  }
  .member_collections_delete_goods span{
    display: inline-block;
    border-radius: 3px;
    text-decoration: none;
    text-align: center;
    vertical-align: top;
    -webkit-transition: .3s;
    transition: .3s;
    cursor: pointer;
    min-width: 60px;
    padding: 0 19px;
    height: 30px;
    border: 1px solid #ffbee0;
    width: 76px;
    background-color: transparent;
    border-color: #e2231a;
    color: #dd2a3c;
    font-size: 13px;
    line-height: 32px;
  }
  .member_collections_goods .member_collections_item:hover .member_collections_delete_goods{
    display: block;
  }
  .footprint_goods_list .member_collections_item{
    margin-right: 8px;
  }
  .footprint_goods_list .member_collections_item:nth-child(4n){
    margin-right: 0;
  }
  .footprint_goods_list .member_collections_item_active{
    border:1px solid #dd2a3c;
  }
  .member_collections_angle{
    width: 40px;
    height: 40px;
    position: absolute;
    right:0;
    bottom:0;
  }
  .member_collections_angle img{
    width: 40px;
    height: 40px;
  }
  .invalid_collections_goods_txt{
    position: absolute;
    top:50%;
    left:50%;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    color:#fff;
    background:rgba(0, 0, 0, .3);
    border-radius: 580%;
    margin-top: -40px;
    margin-left: -40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/footprint.vue